import { apiService } from "@/_services";
import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { timeParse } from "d3";

/**
 * Fetches the latest commodity forecasts and updates the component state.
 *
 * @param {object} _this - Context variables (state management for the component).
 */
export function getComdtyForecast(_this) {
  // Set loading state to indicate data fetching is in progress
  Object.assign(_this.loading, { forecastCommodities: true });
  // API request parameters
  const params = {
    method: "GET",
    endpoint: "commodity_fcst",
    content_type: "application/json",
    query_params: {
      date: formatDate_YMD(new Date()), // Format current date for API request
      format: "json"
    }
  };
  // Perform API request to fetch commodity forecasts
  apiService
    .getAll(params)
    .then(data => {
      parseData(_this, data); // Process and update state with fetched data
    })
    .catch(error => {
      console.error("Error fetching commodity forecasts:", error);
      Object.assign(_this.loading, { forecastCommodities: false }); // Reset loading state
    });
}

/**
 * Parses the fetched commodity forecast data and updates the state.
 *
 * @param {object} _this - Context variables (state management for the component).
 * @param {Array} data - Array of forecast data returned from the API.
 */
function parseData(_this, data) {
  // Extract unique commodities from the data
  let commodityList = data.map(d => ({ pk: d.pk, name: d.name }));
  commodityList = [
    ...new Map(commodityList.map(item => [item.name, item])).values()
  ];
  // Map commodity forecasts to the expected structure
  const forecastData = data.map(d => ({
    update_date: timeParse("%Y-%m-%d")(d.update_date),
    date: timeParse("%Y-%m-%d")(d.objective_date),
    pk: d.pk,
    name: d.name,
    institution: d.institution,
    mean: d.mean
  }));
  // Create a mapping of commodity primary keys (pk) to names
  const commodityByPk = data.reduce((acc, d) => {
    acc[d.pk] = d.name;
    return acc;
  }, {});
  // Update the component state with parsed data
  Object.assign(_this.data, {
    commodityList,
    forecastCommodities: forecastData,
    commodityByPk
  });
  Object.assign(_this.loading, { forecastCommodities: false }); // Reset loading state
}
